import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';

const workflowSlice = createSlice({
  initialState,
  reducers,
  name: 'workflow',
});

export const { setApplication } = workflowSlice.actions;

export default workflowSlice.reducer;
